import { useEffect, useRef } from 'react';

function usePrevious(props) {
    const ref = useRef();
    useEffect(() => {
        ref.current = props;
    });
    return ref.current;
}

// function useCompare(val) {
//     const prevVal = usePrevious(val);
//     return prevVal !== val;
// }
export function useEffectFailure(props, fn = () => {}) {
    const prevProps = usePrevious(props);

    useEffect(() => {
        if (prevProps === "request" && props === "error")
            fn();
        else if (prevProps === false && props === "error")
            fn();
    }, [prevProps, props, fn]);
}

export function useEffectSuccess(props, fn = () => {}) {
    const prevProps = usePrevious(props);

    useEffect(() => {
        if (prevProps === 'request' && props === 'success')
            fn();
        else if (prevProps === false && props === 'success')
            fn();
    }, [prevProps, props, fn]);
}

export function useEffectChange(props, fn = () => {}) {
    const prevProps = usePrevious(props);

    useEffect(() => {
        if (prevProps !== props)
            fn(prevProps, props);
    }, [prevProps, fn, props]);
}
